import Vue from 'vue'
import Vuex from 'vuex'
import { state, mutations } from './mutations.js'
import * as getters from './getters.js'
import * as actions from './actions.js'

/* Modules */
import main from './modules/main'
import asset from './modules/asset'
import orderFood from './modules/orderFood'
import advertising from './modules/advertising'
import intercom from './modules/intercom'
import smartLocker from './modules/smartLocker'

/* Plugins */
import forceLogoutUsersByCommunityPlugin from './plugins/forceLogoutUsersByCommunityPlugin.js'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    main,
    asset,
    orderFood,
    smartLocker,
    advertising,
    intercom
  },
  state,
  mutations,
  getters,
  actions,
  plugins: [forceLogoutUsersByCommunityPlugin],

  // 嚴格模式，禁止直接修改 state
  strict: true
})
